import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../translations';

type PassportValidToFieldProps = FieldControllerProps<'passportValidTo', LocalDate | null>;

export const PassportValidToField = (props: PassportValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={'passportValidTo'}
         controller={props.register(props.name, { required: props.required })}
         defaultValue={props.defaultValue}
         dayValidators={'dayBeforeToday'}
         label={identityDocumentTranslationKeys.passport.passportValidTo.label}
         withNavigationArrows
      />
   );
};
